/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocialShare_seller = {
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly " $refType": "StorefrontSocialShare_seller";
};
export type StorefrontSocialShare_seller$data = StorefrontSocialShare_seller;
export type StorefrontSocialShare_seller$key = {
    readonly " $data"?: StorefrontSocialShare_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocialShare_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontSocialShare_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'dc831e75325ac9ff6898dfc6223ab2ff';
export default node;
